// 2) Third-party libraries
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

// 3.3 Project-specific modules � components/types
import { StoredRouteState } from "./types";

// 3.5 Redux actions / store
import type { RootState } from "../storeTypes";

const actionPrefix = 'storedRoute';

// Type-safe initialState!
export const initialState: StoredRouteState = {
    menuCollapsed: false,
};

const storedRouteSlice = createSlice({
    name: actionPrefix,
    initialState,
    reducers: {
        setMenuCollapsedAction: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.menuCollapsed = action.payload;
        },
    }
});

const { actions, reducer } = storedRouteSlice;

// Actions
export const {
    setMenuCollapsedAction
} = actions;

// Selectors
export const getStoredRouteState = (state: RootState) => state.storedRoute;
export const getMenuCollapsed = createSelector(
    getStoredRouteState,
    (storedRoute) => storedRoute.menuCollapsed
);
// Reducer
export default reducer;